import index from './pages/index'

const routes = [
      {
        path: '/',
        name: 'Index',
        component: index
      }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/index/routes.js